<template>
  <v-container class="page-not-found">
    <div>
      <span class="display-3 white--text font-weight-regular">Страница не найдена</span>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>

<style scoped>
  .page-not-found {
    width: 100vw;
    height: calc(100vh - 130px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>